import { Button, Flex, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { RuleFormRow } from './RuleFormRow';
import { RuleGroupEditor } from './index';

const { Text } = Typography;

export const GroupContent = ({
  group,
  level,
  ruleFields,
  handleRemoveRule,
  handleRuleChange,
  handleGroupChange,
  handleRemoveGroup,
  handleAddRule,
  handleAddGroup,
  showFieldErrors = false,
  validateGroup,
  groupHasError = false,
}) => {
  const hasRules = group.rules && group.rules.length > 0;
  const hasChildren = group.children && group.children.length > 0;
  const isEmpty = !hasRules && !hasChildren;

  return (
    <>
      <Flex vertical>
        {groupHasError && (
          <Text type='danger' style={{ fontSize: '0.85em', marginBottom: 4 }}>
            Este grupo debe tener al menos una regla válida o un subgrupo con condiciones.
          </Text>
        )}
        {hasRules && group.rules.map((rule, index) => (
          <RuleFormRow
            key={index}
            rule={rule}
            ruleFields={ruleFields}
            onRemove={() => handleRemoveRule(index)}
            onChange={(updatedRule) => handleRuleChange(index, updatedRule)}
            showFieldErrors={showFieldErrors}
          />
        ))}

        {isEmpty && !groupHasError && (
          <Text type='secondary' italic style={{ fontSize: '0.9em', paddingLeft: 8 }}>
            Sin condiciones definidas
          </Text>
        )}

        {hasChildren && group.children.map((childGroup, index) => (
          <RuleGroupEditor
            key={index}
            group={childGroup}
            level={level + 1}
            ruleFields={ruleFields}
            onChange={(updatedGroup) => handleGroupChange(index, updatedGroup)}
            onRemove={() => handleRemoveGroup(index)}
            showFieldErrors={showFieldErrors}
            validateGroup={validateGroup}
          />
        ))}
      </Flex>

      <Flex gap='small' justify='flex-start'>
        <Button
          color='primary'
          variant='text'
          icon={<PlusOutlined />}
          onClick={handleAddRule}
          size='small'
        >
          Agregar regla
        </Button>
        <Button
          color='primary'
          variant='text'
          icon={<PlusOutlined />}
          onClick={handleAddGroup}
          size='small'
        >
          Agregar grupo
        </Button>
      </Flex>
    </>
  );
};
